<template>
  <div class="prize" @click="routeTo">
    <!-- <router-link :to="{ path: advertisingInfo.href || '' }"> -->
      <img :src="advertisingInfo.img" />
    <!-- </router-link> -->
  </div>
</template>
<script>
export default {
  props: {
    advertisingInfo: {
      type: Object,
      default: Object
    }
  },
  methods: {
    routeTo () {

      this.$router.push({
        path: this.advertisingInfo.href
      })
    }
  },
}
</script>
<style scoped>
.prize {
  margin: 0.1rem 0;
}
</style>
